import { Injectable, Inject } from 'ng-metadata/core';
import {IGeneralAlertMsg} from "../../../infra/widgets/alerts/alertMsg.interface";
import {ALERT_MSG_TYPE, AlertFactory} from "../../../infra/widgets/alerts/alertFactory.service";
import { HttpService } from '../../../infra/httpRequest/http.service';
import { getInstitutionCode, isNgrs } from '../../../appConfig/appConfigForward';
import { JwtUtilService } from "../../../security/jwtUtil.service";
const get= require('lodash/get');


@Injectable()
export class NgrsService {
    
    public item:Object;
    private _signInLink: IGeneralAlertMsg;
    private _signInLinkRequest: IGeneralAlertMsg;
    private _showBestOffer: boolean = true;
    private _supplyTime: number = 0;
    private _loanPeriod: number = 0;
    private _ngrsVisibilityService:object={};
    private resquestInProgress:Object = {};
    private institutionCode:string= getInstitutionCode();
    private ngrsRSSystemChecksUrl:any;
    private ngrsRSNoOfferMessageUrl:any;
    private ngrsFormsCustomizationURL:any;
    private ngrsVisibilityResponseByMmsId:Object = {};

    
    constructor (private httpService: HttpService,
        private alertFactory :AlertFactory,
        private jwtUtilService: JwtUtilService,
        @Inject('restBaseURLs') private restBaseURLs) {

        this.ngrsRSSystemChecksUrl = restBaseURLs.ngrsResourceSharingServiceEnabledURL;   
        this.ngrsRSNoOfferMessageUrl =  restBaseURLs.ngrsNoOfferMessageURL;
        this.ngrsFormsCustomizationURL = restBaseURLs.rapidoFormsCustomizationURL;
        this.initSignInLink();
        this.initSignInLinkRequest();
        this.initNgrsVisibilityServices();
    }

    private initNgrsVisibilityServices(){
        this._ngrsVisibilityService = {
            '/ngrsRSServiceEnabledURL': {
                'path': this.ngrsRSSystemChecksUrl,     
                'method': 'POST',
            }
        };
    }

    public getRapidoNoOfferMessage() {
        return this.httpService.call('GET', this.ngrsRSNoOfferMessageUrl, {})
            .then(
                (response)=> {
                    return response;
                },
                (error)=>{
                    console.log('=================> Failed to find no rapido message');
                }
            );
    }

    public isNgrsRSServiceEnabled(recordId:string, physicalServiceId:string, item, isJournal:boolean){
        let payload = {
            'doc': item
        };   
        
        let path = this.ngrsRSSystemChecksUrl + '?record-institution=' + this.institutionCode;
        
        if(recordId) {
        	path = path + '&recordId=' + recordId;
        } 
        
        if(physicalServiceId) {
        	path = path + '&physicalServiceId=' + physicalServiceId;
        } 
        path = path + '&isJournal=' + isJournal+ '&isRapido='+window.sessionStorage.getItem("isRapido");
        return this.makeIlsRequest('/ngrsRSServiceEnabledURL', path, payload);
    }


    public makeIlsRequest(serviceName: string, servicePath: string, params: Object){
        if(!isNgrs()){
            return;
        }
        if(!params){
            params= {};
        }
        let ngrsService = this._ngrsVisibilityService[serviceName];
        this.resquestInProgress[serviceName] = true;
        
        let path = servicePath;
        if(!servicePath) {
        	path = ngrsService.path;
        }

        return this.httpService.call(ngrsService.method, path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response, params);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName);
                }
            ).finally( () =>{
                this.resquestInProgress[serviceName] = false;
            });
    }

    get ngrsVisibilityRequestInProgress(){
        if(this.resquestInProgress && this.resquestInProgress['/ngrsRSServiceEnabledURL']){
            return this.resquestInProgress['/ngrsRSServiceEnabledURL'];
        }
        return false;
    }

    private ilsRequestSuccess(response, params: Object){
        let recordIdhash = this.jwtUtilService.getDecodedToken().userGroup + '_' + params['recordId'];
        this.ngrsVisibilityResponseByMmsId[recordIdhash] = response;
        return response;
    }

    public getResponseByRecordId(recordId:string){
        let recordIdhash = this.jwtUtilService.getDecodedToken().userGroup + '_' + recordId;
        return this.ngrsVisibilityResponseByMmsId[recordIdhash];
    }

    public resetNgrsVisibilityResponse() {
        this.ngrsVisibilityResponseByMmsId = {};
        this.resquestInProgress = {};
    }

    private ilsRequestFailure(reason, serviceName) {
        console.error(reason, serviceName);
        return reason;
    }

    private initSignInLink(){
        this._signInLink = this.alertFactory.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
        let html =
        '<span class="bar-text margin-right-small" translate="nui.ngrs.signin"></span>' +
        '<prm-authentication [is-logged-in]="ctrl.isSignedIn()" flex="none"></prm-authentication>';

        this._signInLink.show(html);
    }

    private initSignInLinkRequest(){
        this._signInLinkRequest = this.alertFactory.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
        let html =
        '<span class="bar-text margin-right-small" translate="nui.ngrs.get.it.request.signin"></span>' +
        '<prm-authentication [is-logged-in]="ctrl.isSignedIn()" flex="none"></prm-authentication>';

        this._signInLinkRequest.show(html);
    }    

    get signInLink() {
        return this._signInLink;
    }

    set signInLink(value) {
        this._signInLink = value;
    }

    get signInLinkRequest() {
        return this._signInLinkRequest;
    }

    set signInLinkRequest(value) {
        this._signInLinkRequest = value;
    }    

    public getRapidoFormsCustomization() {
        return this.httpService.call('GET', this.ngrsFormsCustomizationURL, {})
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response, {});
                },
                (error)=>{
                    console.error(error, 'ngrsRequestFormsCustomization failed');
                    return error;
                }
            );
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.service.ts